export const TrackingPageZone = 'Featured Tiles'
